// Serviço GLOBAL de relatórios/PDF do NEXO LOG.
// Reutilizável por qualquer módulo: monta cabeçalho (logo empresa ou NEXO LOG),
// filtros, indicadores, tabela (com cabeçalho repetido por página), totais e rodapé.
import { openPrint } from "@/lib/print";

const esc = (v) => String(v ?? "").replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));

// Logo padrão NEXO LOG (usado quando a empresa não tem logo cadastrada)
const NEXO_BRAND = `<div style="display:flex;align-items:center;gap:8px">
  <div style="width:34px;height:34px;border-radius:7px;background:#f59e0b;display:flex;align-items:center;justify-content:center;font-weight:800;color:#111">⚡</div>
  <div style="font-weight:800;font-size:20px;letter-spacing:-.5px">NEXO<span style="color:#f59e0b">LOG</span></div>
</div>`;

export function buildReportHTML({
  empresa = {}, logoUrl = null, titulo = "Relatório", periodoLabel = "", filtros = [],
  indicadores = [], colunas = [], linhas = [], totais = [], usuario = "", orientacao = "retrato",
}) {
  const nomeEmpresa = empresa.nome_fantasia || empresa.nome || "NEXO LOG";
  const logoHTML = logoUrl
    ? `<img src="${esc(logoUrl)}" style="max-height:54px;max-width:180px;object-fit:contain" crossorigin="anonymous"/>`
    : NEXO_BRAND;
  const geradoEm = new Date().toLocaleString("pt-BR");

  const filtrosHTML = filtros.length
    ? `<div class="filtros">${filtros.map((f) => `<span><b>${esc(f.label)}:</b> ${esc(f.valor)}</span>`).join("")}</div>` : "";

  const indHTML = indicadores.length
    ? `<div class="inds">${indicadores.map((i) => `<div class="ind"><div class="ind-v">${esc(i.valor)}</div><div class="ind-l">${esc(i.label)}</div></div>`).join("")}</div>` : "";

  const thead = `<thead><tr>${colunas.map((c) => `<th style="text-align:${c.align || "left"}${c.width ? `;width:${c.width}` : ""}">${esc(c.label)}</th>`).join("")}</tr></thead>`;
  const tbody = `<tbody>${linhas.map((r) => `<tr>${colunas.map((c) => `<td style="text-align:${c.align || "left"}">${esc(r[c.key])}</td>`).join("")}</tr>`).join("")}</tbody>`;
  const tfoot = totais.length
    ? `<tfoot><tr>${colunas.map((c, i) => i === 0 ? `<td><b>Totais</b></td>` : `<td style="text-align:${c.align || "left"}"><b>${esc((totais.find((t) => t.key === c.key) || {}).valor ?? "")}</b></td>`).join("")}</tr></tfoot>` : "";

  const tabela = colunas.length
    ? `<table>${thead}${tbody}${tfoot}</table>`
    : `<div class="vazio">Sem dados para os filtros selecionados.</div>`;

  const html = `<!doctype html><html lang="pt-BR"><head><meta charset="utf-8"><title>${esc(titulo)}</title>
<style>
  @page { size: A4 ${orientacao === "paisagem" ? "landscape" : "portrait"}; margin: 12mm 10mm 16mm; }
  * { box-sizing: border-box; }
  body { font-family: Arial, Helvetica, sans-serif; color: #111; margin: 0; font-size: 11px; }
  header { display:flex; justify-content:space-between; align-items:flex-start; border-bottom:2px solid #111; padding-bottom:8px; margin-bottom:10px; }
  .co { text-align:right; }
  .co .nome { font-weight:800; font-size:15px; text-transform:uppercase; }
  .co .sub { color:#555; font-size:10px; }
  h1 { font-size:16px; margin:2px 0 2px; }
  .periodo { color:#333; font-size:11px; margin-bottom:6px; }
  .filtros { display:flex; flex-wrap:wrap; gap:4px 14px; font-size:10px; color:#333; margin-bottom:10px; }
  .inds { display:flex; flex-wrap:wrap; gap:8px; margin-bottom:12px; }
  .ind { border:1px solid #ccc; border-radius:6px; padding:6px 12px; min-width:110px; }
  .ind-v { font-size:17px; font-weight:800; }
  .ind-l { font-size:9px; text-transform:uppercase; color:#666; letter-spacing:.4px; }
  table { width:100%; border-collapse:collapse; }
  thead { display: table-header-group; }
  th, td { border:1px solid #ddd; padding:5px 6px; font-size:10px; }
  th { background:#f3f3f3; text-transform:uppercase; font-size:9px; letter-spacing:.3px; }
  tr { break-inside: avoid; }
  tfoot td { background:#f9f9f9; }
  .vazio { padding:24px; text-align:center; color:#777; border:1px dashed #ccc; border-radius:6px; }
  .foot { position:fixed; bottom:6mm; left:10mm; right:10mm; display:flex; justify-content:space-between; font-size:8px; color:#888; border-top:1px solid #ddd; padding-top:3px; }
</style></head>
<body>
  <header>
    <div>${logoHTML}</div>
    <div class="co"><div class="nome">${esc(nomeEmpresa)}</div>${empresa.cnpj ? `<div class="sub">CNPJ ${esc(empresa.cnpj)}</div>` : ""}${empresa.endereco ? `<div class="sub">${esc(empresa.endereco)}</div>` : ""}</div>
  </header>
  <h1>${esc(titulo)}</h1>
  ${periodoLabel ? `<div class="periodo">${esc(periodoLabel)}</div>` : ""}
  ${filtrosHTML}
  ${indHTML}
  ${tabela}
  <div class="foot"><span>Gerado em ${esc(geradoEm)}${usuario ? ` · por ${esc(usuario)}` : ""}</span><span>NEXO LOG</span></div>
</body></html>`;
  return html;
}

export function gerarRelatorioPDF(opts) {
  openPrint(buildReportHTML(opts));
}
